<template>
    <div class="jumbotron descubre-hero">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <h1>El Talmud en español y en la palma de tu mano</h1>
                    <h5 style="font-weight:300!important" class="mb-5">Jabrutouch es la primera aplicación móvil para estudiar el Talmud a tu ritmo y en tu idioma. Accede a la sabiduría milenaria más preciada del judaísmo con un par de clics.</h5>
                    <a href="https://play.google.com/store/apps/details?id=co.il.jabrutouch"><img :src="require('../assets/images/g-play.png')" alt=""></a>
                    <a href="https://apps.apple.com/il/app/jabrutouch/id1488439011"><img :src="require('../assets/images/app-store.png')" alt=""></a>
                </div>
                <div class="col-4 d-none d-sm-block">
                    <img :src="require('../assets/images/descubre.png')" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
    .jumbotron.descubre-hero{
        background: linear-gradient(0, #64B2E2 22.37%, rgba(255, 255, 255, 0) 78.57%), #83C9F4;
        color: #fff;
        border-radius: 0;
    }
    .descubre-hero-phone.img-fluid{
        max-width: initial;
        position: absolute;
        width: 120%;
        top: 0;
        right: 0;
    }
</style>